import React, { useState, useEffect, useCallback } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import LoadingImage from "./assets/Loading.gif";
import { IoCarSportOutline } from "react-icons/io5";
import HTTP_BASE_URL from "../constants/HttpConstants";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const toastrOptions = {
  position: "top-center",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const CarDetails = ({ close, id }) => {
  const customertoken = localStorage.getItem("customertoken");
  const navigate = useNavigate();
  const [carData, setCarData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [closePopup, setClosePopup] = useState();
  const [suggestions, setSuggestions] = useState({
    carmake: [],
    cartype: [],
    carmodel: [],
    carcolour: [],
    insurance_company: [],
  });
  const [inputValues, setInputValues] = useState({});

  const getFullDetails = useCallback(() => {
    const myHeaders = new Headers();
    myHeaders.append("access-token", "508b1430-68f0-4b2f-9003-3c2a0eb2a54a");
    myHeaders.append("customertoken", customertoken);
    const formdata = new FormData();
    formdata.append("id", id);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(HTTP_BASE_URL + "getBookingdetails", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.code === 0) {
          setInputValues(result.data.booking_details);
          // console.log('location', result.data);
        } else {
          navigate("/");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [id, customertoken, navigate]);

  const carModel = useCallback(() => {
    fetch(`${HTTP_BASE_URL}getCarModel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        customertoken: customertoken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.code === 0) {
          const carDataArray = [];
          Object.keys(data.data).forEach((make) => {
            Object.keys(data.data[make]).forEach((model) => {
              Object.keys(data.data[make][model]).forEach((type) => {
                const colors = data.data[make][model][type];
                colors.forEach((color) => {
                  carDataArray.push({ make, model, type, color });
                });
              });
            });
          });
          setCarData(carDataArray);
        } else {
          navigate("/");
        }
      })
      .catch((error) => console.error("Error fetching car data:", error));
  }, [customertoken, navigate]);

  const tokenExpiry = useCallback(() => {
    if (!customertoken) {
      // Step 1: Clear storage
      localStorage.clear(); // or sessionStorage.clear();
      // Step 2: Redirect to login or home page
      navigate("/", { replace: true });
      // Step 3: Prevent going back to the previous page
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
      };
    }
  }, [customertoken, navigate]);

  useEffect(() => {
    getFullDetails();
    carModel();
    tokenExpiry();
  }, [getFullDetails, carModel, tokenExpiry]);

  const fetchCarMakes = (query) => {
    fetch(HTTP_BASE_URL + "getCarModel", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        customertoken: customertoken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const carDataArray = [];
        Object.keys(data.data).forEach((make) => {
          Object.keys(data.data[make]).forEach((model) => {
            Object.keys(data.data[make][model]).forEach((type) => {
              const colors = data.data[make][model][type];
              colors.forEach((color) => {
                carDataArray.push({ make, model, type, color });
              });
            });
          });
        });

        setCarData(carDataArray);
        const filteredMakes = [
          ...new Set(
            carDataArray
              .filter((item) =>
                item.make.toLowerCase().includes(query.toLowerCase())
              )
              .map((item) => item.make)
          ),
        ];
        setSuggestions((prev) => ({ ...prev, carmake: filteredMakes }));
      })
      .catch((error) => console.error("Error fetching car makes:", error));
  };

  const handleTypeKeyPress = (event) => {
    const query = event.target.value;
    setInputValues((prev) => ({ ...prev, cartype: query })); // Update input value dynamically
    // fetchCarTypes(inputValues.carmake, query);
    const filteredTypes = [
      ...new Set(
        carData
          .filter(
            (item) =>
              item.make === inputValues.carmake &&
              item.model === inputValues.carmodel &&
              item.type.toLowerCase().includes(query.toLowerCase())
          )
          .map((item) => item.type)
      ),
    ];
    setSuggestions((prev) => ({ ...prev, cartype: filteredTypes }));
  };

  const handleModelKeyPress = (event) => {
    const query = event.target.value;
    setInputValues((prev) => ({ ...prev, carmodel: query })); // Update input value dynamically
    fetchCarModels(inputValues.carmake, query); // Fetch matching models
  };

  const fetchCarModels = (selectedMake, query) => {
    if (!selectedMake) return; // Ensure parent selections are made
    const filteredModels = [
      ...new Set(
        carData
          .filter(
            (item) =>
              item.make === selectedMake &&
              // item.type === selectedType &&
              item.model.toLowerCase().includes(query.toLowerCase())
          )
          .map((item) => item.model)
      ),
    ];
    setSuggestions((prev) => ({
      ...prev,
      carmodel: filteredModels.length > 0 ? filteredModels : false, // Handle empty results
    }));
  };
  const handleColorKeyPress = (event) => {
    const query = event.target.value;
    setInputValues((prev) => ({ ...prev, carcolour: query })); // Update input value dynamically
    fetchCarColours(
      inputValues.carmake,
      inputValues.cartype,
      inputValues.carmodel,
      query
    ); // Fetch matching colors
  };
  const fetchCarColours = (
    selectedMake,
    selectedType,
    selectedModel,
    query
  ) => {
    if (!selectedMake || !selectedType || !selectedModel) return; // Ensure parent selections are made
    const filteredColors = [
      ...new Set(
        carData
          .filter(
            (item) =>
              item.make === selectedMake &&
              item.type === selectedType &&
              item.model === selectedModel &&
              item.color.toLowerCase().includes(query.toLowerCase())
          )
          .map((item) => item.color)
      ),
    ];
    setSuggestions((prev) => ({
      ...prev,
      carcolour: filteredColors.length > 0 ? filteredColors : false, // Handle empty results
    }));
  };

  const hangleInsuranceKeyPress = (event) => {
    const query = event.target.value;
    setInputValues((prev) => ({ ...prev, insurance_company: query }));
    fetchInsuranceComapnyList(query);
  };

  const fetchInsuranceComapnyList = (query) => {
    fetch(HTTP_BASE_URL + "getInsuranceCompanyList", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        customertoken: customertoken,
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.data) {
          const filteredNames = [
            ...new Set(
              result.data
                .filter((item) =>
                  item.name.toLowerCase().includes(query.toLowerCase())
                )
                .map((item) => item.name)
            ),
          ];
          setSuggestions((prev) => ({
            ...prev,
            insurance_company: filteredNames.length > 0 ? filteredNames : false,
          }));
        }
      })
      .catch((error) => {
        console.error("Error Fetching Insurance Comapany Name:", error);
        setSuggestions((prev) => ({ ...prev, insurance_company: [] }));
      });
  };

  const handleOnChange = (e) => {
    const { name, value, checked, type } = e.target;
    setInputValues({
      ...inputValues,
      [name]: type === "checkbox" ? checked : value,
    });
    if (name === "carmake") {
      fetchCarMakes(value);
    }
    const error = validateField(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };
  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "carmake":
      case "cartype":
      case "carcolour":
        if (!value) {
          error = "This field is required.";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z\s.-]+$/.test(value)) {
          error = "Only letters, spaces, hyphens, and periods are allowed.";
        }
        break;
      case "carno":
        if (!value) {
          error = "This field is required.";
        } else if (
          !/^[a-zA-Z]{2}\s*\d{2}\s*[a-zA-Z0-9]{1,2}\s*\d{4}$/.test(value)
        ) {
          error = "Please enter a valid vehicle number (e.g., DL 10 AN 1123).";
        }
        break;
      case "chasisno":
      case "engineno":
        if (!value) {
          error = "";
        } else if (value === "null") {
          error = "";
        } else if (!/^[0-9A-Za-z\s]{7,20}$/.test(value)) {
          error = "Please enter a valid number (7-20 alphanumeric characters).";
        }
        break;
      case "insurance_no":
        if (!value) {
          error = "";
        } else if (value === "null") {
          error = "";
        } else if (!/^[-0-9A-Za-z\s/]{7,20}$/.test(value)) {
          error =
            "Please enter a valid number (7-20 alphanumeric characters, spaces, slash, and hyphen are allowed).";
        }
        break;
      case "carmodel":
        if (!value) {
          error = "This field is required.";
        }
        break;
      case "insurance_company":
        if (!value) {
          error = "";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z\s.-]+$/.test(value)) {
          error = "Only letters, spaces, hyphens, and periods are allowed.";
        }
        break;
      default:
        break;
    }
    return error;
  };

  const handleSuggestionClick = (field, value) => {
    setInputValues((prev) => ({ ...prev, [field]: value }));
    setSuggestions((prev) => ({ ...prev, [field]: [] }));
    validateField(field, value);
    const error = validateField(field, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: error,
    }));
  };

  const CarDetailSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};
    setInputValues({});
    // Validate fields and collect errors
    Object.keys(inputValues).forEach((fieldName) => {
      const error = validateField(fieldName, inputValues[fieldName]);
      if (error) newErrors[fieldName] = error;
    });
    if (Object.keys(newErrors).length > 0) {
      // alert('Please fill in all fields correctly');
      toast.warning("Please ensure all fields are filled in correctly.", {
        toastrOptions,
      });
      // console.log(newErrors)
      return;
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true); // Show loading spinner

      // Handle payment type-specific logic
      let updatedValues = { ...inputValues };
      // if (inputValues.payment_type === "1") {
      //     updatedValues.company_name = "null";
      //     updatedValues.bill_status = "0";
      // }
      // Create FormData for submission
      const formData = new FormData();
      Object.keys(updatedValues).forEach((key) => {
        formData.append(key, updatedValues[key]);
      });
      formData.append("bookingid", id);
      // console.log('formData', formData)
      try {
        // Simulate delay for spinner demo
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Submit the form data via API
        const response = await fetch(HTTP_BASE_URL + "updateBookingdetails", {
          method: "post",
          headers: {
            "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
            customertoken: customertoken,
          },
          body: formData,
        });

        const result = await response.json();

        // Handle API response
        if (result.code === 0) {
          //  console.log("Form submitted successfully:", result);
          setIsSubmitted(true);
          toast.success("Car details saved successfully!", { toastrOptions });
          setTimeout(function () {
            window.location.reload();
            setClosePopup(close);
          }, 1500);
        } else if (result.code === 1) {
          toast.error("Please complete all required fields correctly.", {
            toastrOptions,
          });
        }
      } catch (error) {
        console.error("Submission failed:", error);
        // alert("An error occurred. Please try again.");
      } finally {
        setIsSubmitting(false); // Hide loading spinner
      }
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="fromModel">
        <div className="billingModal-content">
          <div className="div">
            <div className="gstModel-header">
              <p className="addGst">
                <IoCarSportOutline /> Car Details
              </p>
              <div className="btn-close" onClick={() => close(false)}>
                <AiOutlineCloseCircle />
              </div>
            </div>
            <div className="modal-body">
              <form
                onSubmit={CarDetailSubmit}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // Stops form submit
                  }
                }}
                autoComplete="off"
              >
                <div className="row p-0 m-0">
                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="carno" className="form-label">
                      Car Number <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="carno"
                      name="carno"
                      disabled={isSubmitting || isSubmitted}
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      value={
                        inputValues
                          ? inputValues?.carno === "null" || !inputValues?.carno
                            ? ""
                            : inputValues?.carno
                          : ""
                      }
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: DL10N1123"
                    />
                    {errors.carno && (
                      <p className="text-para red">{errors.carno}</p>
                    )}
                  </div>
                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="carmake" className="form-label">
                      Car Make <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="carmake"
                      name="carmake"
                      disabled={isSubmitting || isSubmitted}
                      value={
                        inputValues
                          ? inputValues?.carmake === "null" ||
                            !inputValues?.carmake
                            ? ""
                            : inputValues?.carmake
                          : ""
                      }
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: Maruti Suzuki"
                    />
                    {errors.carmake && (
                      <p className="text-para red">{errors.carmake}</p>
                    )}
                    {suggestions.carmake.length > 0 && (
                      <ul>
                        {suggestions.carmake.map((make) => (
                          <li
                            key={make}
                            onClick={() =>
                              handleSuggestionClick("carmake", make)
                            }
                          >
                            {make}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="carmodel" className="form-label">
                      Car Model <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="carmodel"
                      name="carmodel"
                      disabled={isSubmitting || isSubmitted}
                      value={
                        inputValues
                          ? inputValues?.carmodel === "null" ||
                            !inputValues?.carmodel
                            ? ""
                            : inputValues?.carmodel
                          : ""
                      }
                      onKeyDown={handleModelKeyPress}
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: Ertiga"
                    />
                    {errors.carmodel && (
                      <p className="red text-para">{errors.carmodel}</p>
                    )}

                    {suggestions.carmodel.length > 0 && (
                      <ul>
                        {suggestions.carmodel.map((model) => (
                          <li
                            key={model}
                            onClick={() =>
                              handleSuggestionClick("carmodel", model)
                            }
                          >
                            {model}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="cartype" className="form-label">
                      Body Type <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="cartype"
                      name="cartype"
                      disabled={isSubmitting || isSubmitted}
                      value={
                        inputValues
                          ? inputValues?.cartype === "null" ||
                            !inputValues?.cartype
                            ? ""
                            : inputValues?.cartype
                          : ""
                      }
                      onKeyDown={handleTypeKeyPress}
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: Sedan"
                    />
                    {errors.cartype && (
                      <p className="red text-para">{errors.cartype}</p>
                    )}
                    {suggestions.cartype.length > 0 && (
                      <ul>
                        {suggestions.cartype.map((type) => (
                          <li
                            key={type}
                            onClick={() =>
                              handleSuggestionClick("cartype", type)
                            }
                          >
                            {type}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="carcolour" className="form-label">
                      Car Color <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="carcolour"
                      name="carcolour"
                      disabled={isSubmitting || isSubmitted}
                      value={
                        inputValues
                          ? inputValues?.carcolour === "null" ||
                            !inputValues?.carcolour
                            ? ""
                            : inputValues?.carcolour
                          : ""
                      }
                      onChange={handleOnChange}
                      onKeyDown={handleColorKeyPress}
                      className="form-control"
                      placeholder="Eg: White"
                    />
                    {errors.carcolour && (
                      <p className="red text-para">{errors.carcolour}</p>
                    )}

                    {suggestions.carcolour.length > 0 && (
                      <ul>
                        {suggestions.carcolour.map((color) => (
                          <li
                            key={color}
                            onClick={() =>
                              handleSuggestionClick("carcolour", color)
                            }
                          >
                            {color}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="chasisno" className="form-label">
                      Chasis No
                    </label>
                    <input
                      type="text"
                      id="chasisno"
                      name="chasisno"
                      disabled={isSubmitting || isSubmitted}
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      value={
                        inputValues
                          ? inputValues?.chasisno === "null" ||
                            !inputValues?.chasisno
                            ? ""
                            : inputValues?.chasisno
                          : ""
                      }
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: KC9J89LXUELE35433"
                    />
                    {errors.chasisno && (
                      <p className="red text-para">{errors.chasisno}</p>
                    )}
                  </div>

                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="engineno" className="form-label">
                      Engine No
                    </label>
                    <input
                      type="text"
                      id="engineno"
                      name="engineno"
                      disabled={isSubmitting || isSubmitted}
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      value={
                        inputValues
                          ? inputValues?.engineno === "null" ||
                            !inputValues?.engineno
                            ? ""
                            : inputValues?.engineno
                          : ""
                      }
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: JYCHH16005"
                    />
                    {errors.engineno && (
                      <p className="red text-para">{errors.engineno}</p>
                    )}
                  </div>
                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="insurance_no" className="form-label">
                      Insurance Policy No
                    </label>
                    <input
                      type="text"
                      id="insurance_no"
                      name="insurance_no"
                      disabled={isSubmitting || isSubmitted}
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      value={
                        inputValues
                          ? inputValues?.insurance_no === "null" ||
                            !inputValues?.insurance_no
                            ? ""
                            : inputValues?.insurance_no
                          : ""
                      }
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: 2022/525/2585"
                    />
                    {errors.insurance_no && (
                      <p className="red text-para">{errors.insurance_no}</p>
                    )}
                  </div>
                  <div className="col form-col col-md-6 col-12">
                    <label htmlFor="insurance_company" className="form-label">
                      Insurance Company
                    </label>
                    <input
                      type="text"
                      id="insurance_company"
                      name="insurance_company"
                      disabled={isSubmitting || isSubmitted}
                      value={
                        inputValues
                          ? inputValues?.insurance_company === "null" ||
                            !inputValues?.insurance_company
                            ? ""
                            : inputValues?.insurance_company
                          : ""
                      }
                      onKeyDown={hangleInsuranceKeyPress}
                      onChange={handleOnChange}
                      className="form-control"
                      placeholder="Eg: ICICI Lombard"
                    />
                    {errors.insurance_company && (
                      <p className="red text-para">
                        {errors.insurance_company}
                      </p>
                    )}

                    {suggestions.insurance_company &&
                      suggestions.insurance_company.length > 0 && (
                        <ul>
                          {suggestions.insurance_company.map((name) => (
                            <li
                              key={name}
                              onClick={() =>
                                handleSuggestionClick("insurance_company", name)
                              }
                            >
                              {name}
                            </li>
                          ))}
                          <li></li>
                        </ul>
                      )}
                  </div>
                </div>
                <div className="modal-footer pt-lg-2rm pt-4 text-center">
                  <button
                    type="submit"
                    className="submit-btn mb-0"
                    disabled={isSubmitting || isSubmitted}
                  >
                    {isSubmitting
                      ? "Submitting..."
                      : isSubmitted
                      ? "Submitted"
                      : "Submit"}
                    <span className="sub-loading">
                      {isSubmitting && (
                        <img
                          src={LoadingImage}
                          alt="Progress indicator"
                          width={25}
                          height={25}
                          loading="eager"
                        />
                      )}
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarDetails;
